module.exports = __webpack_public_path__ + "static/media/Viktor Krum 2.bdb97b74.jpg";